import { PureComponent } from 'react';

import SimpleTag from '@atlaskit/tag/simple-tag';

import TagIcon from './tag-icon';

type Props = {
  /** The name of the tag. */
  name: string;
};

// eslint-disable-next-line import/no-default-export
export default class RefTag extends PureComponent<Props> {
  render() {
    return (
      <SimpleTag
        text={this.props.name}
        elemBefore={<TagIcon label={this.props.name} />}
      />
    );
  }
}
